import { SectionsPage } from "@/components/SectionsPage";

export default function ProductSafeMe() {
  return (
    <SectionsPage
      seoTitle="BArecord Secure Communications Intelligence | Aliwer"
      seoDescription="BArecord captures your business communications, scores compliance risk with AI, enables plain-English search, and generates executive briefings."
      path="/products/safeme"
      eyebrow="Product · BArecord"
      title="Your business, captured, scored, and governed."
      subtitle="BArecord is a secure communications-intelligence platform. Capture emails, meetings, calls, chats, and notes, score compliance risk with AI, and prove governance."
      sections={[
        { heading: "Capture everything", body: "Record communications with structured metadata across email, meetings, calls, chats, and notes." },
        { heading: "AI risk scoring", body: "Automatically score each item for compliance risk with clear reasons you can act on." },
        { heading: "Plain-English search", body: "Ask questions across your communications and get grounded answers instantly." },
        { heading: "Executive briefings", body: "Generate concise briefings and weekly summaries for leadership and governance." },
      ]}
      cta={{ label: "Open BArecord", to: "/barecord" }}
      testid="product-safeme"
    />
  );
}
